import { Close } from '@mui/icons-material';
import { LoadingButton } from '@mui/lab';
import { Avatar, Dialog, DialogActions, DialogContent, DialogTitle, IconButton, Typography } from '@mui/material';
import { alpha } from '@mui/material/styles';
import { Scrollbar } from 'app/components';
import { InspectionIcon } from 'app/icons';
import { ChecklistTemplateForm } from 'app/pages/Checklist';
import { useAsyncAction } from 'app/services';
import { templateCreate } from 'app/store/checklist';
import React, { useEffect, useRef } from 'react';

const ChecklistTemplateDialog = (props) => {
  const formRef = useRef();
  const { open, onClose, defaultValues } = props;

  const {
    asyncAction: createSubmit,
    isLoading: isCreateLoading,
    isSuccessful: isCreateSuccessful,
  } = useAsyncAction(templateCreate, [open]);

  useEffect(() => {
    if (isCreateSuccessful) {
      onClose();
    }
  }, [isCreateSuccessful]);

  return (
    <Dialog
      maxWidth='md'
      fullWidth
      open={open}
      onClose={onClose}
      sx={(theme) => ({
        width: '100%',
        height: '100%',
        '.MuiDialog-paper': {
          minWidth: '500px',
        },
        '.MuiDialogTitle-root': {
          display: 'flex',
          padding: theme.spacing(2),
          alignItems: 'center',
        },
        '.MuiDialogTitle-root .MuiTypography-root': {
          marginLeft: theme.spacing(1.5),
        },
        '.MuiDialogTitle-root .MuiButtonBase-root': {
          marginLeft: 'auto',
        },
        '.MuiDialogContent-root': {
          padding: theme.spacing(0),
        },
        '.MuiDialogContent-root .simplebar-container': {
          padding: theme.spacing(0, 2),
        },
        '.MuiDialogActions-root': {
          padding: theme.spacing(2),
          justifyContent: 'flex-end',
        },
        '.MuiAvatar-circular': {
          bgcolor: alpha(theme.palette.primary.main, 0.12),
          svg: {
            width: '18px',
            height: '18px',
          },
          'path, circle': {
            fill: theme.palette.primary.main,
          },
        },
        '.MuiAlert-root': {
          marginTop: theme.spacing(1),
          marginBottom: theme.spacing(2),
          borderRadius: theme.shape.borderRadius,
        },
      })}>
      <DialogTitle>
        <Avatar>
          <InspectionIcon fontSize='small' />
        </Avatar>
        <Typography component='p'>Добавить шаблон</Typography>
        <IconButton color='default' onClick={onClose}>
          <Close fontSize='small' />
        </IconButton>
      </DialogTitle>
      <DialogContent>
        <Scrollbar>
          <ChecklistTemplateForm ref={formRef} defaultValues={defaultValues} onSubmit={createSubmit} />
        </Scrollbar>
      </DialogContent>
      <DialogActions>
        <LoadingButton
          variant='contained'
          color='primary'
          loading={isCreateLoading}
          onClick={() => formRef.current?.handleFormSubmit()}
          disableElevation>
          Добавить
        </LoadingButton>
      </DialogActions>
    </Dialog>
  );
};

export default ChecklistTemplateDialog;
